import React from "react";
import { Link } from "react-router-dom";

function Register(props) {
  return (
    <>
      {" "}
      <div className="content-center">
        <div className="dx-popup-content dx-signin text-center">
          <h1 className="h3 text-white mb-30">Sign Up</h1>
          <form action="#" className="dx-form">
            <div className="dx-form-group-md">
              <Link
                to="/account"
                className="dx-btn dx-btn-block dx-btn-popup dx-btn-envato d-flex align-items-center justify-content-center"
              >
                <span className="fas fa-leaf mr-20"></span>
                <span>Sign Up with Envato</span>
              </Link>
            </div>
            <div className="dx-form-group-md">
              <div className="dx-signin-or">OR</div>
            </div>
            <div className="dx-form-group-md">
              <input
                type="text"
                className="form-control form-control-style-4"
                placeholder="Username"
              />
            </div>
            <div className="dx-form-group-md">
              <input
                type="email"
                className="form-control form-control-style-4"
                aria-describedby="emailHelp"
                placeholder="Email"
              />
            </div>
            <div className="dx-form-group-md">
              <input
                type="password"
                className="form-control form-control-style-4"
                placeholder="Password"
              />
            </div>
            <div className="dx-form-group-md">
              <input
                type="password"
                className="form-control form-control-style-4"
                placeholder="Confirm password"
              />
            </div>
            <div className="dx-form-group-md">
              <Link to="/account" className="dx-btn dx-btn-block dx-btn-popup">
                Sign Up
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Register;
